<template>
  <div class="nonreactive-check">
    <div
      class="el-input-group el-input-group--append el-input-group--prepend"
    >
      <div class="el-input-group__prepend">Is</div>
      <el-select
        id="eye-state-select"
        v-close-on-zoom
        :value="state.check.id"
        placeholder="Select eye"
        class="eye-state-select"
        :disabled="readonly"
        @input="value => updateEye(value)"
      >
        <el-option
          v-for="vital in state.eyeStates"
          :key="vital.key"
          :label="vital.name.en"
          :value="vital.key"
        />
      </el-select>
    </div>
    <md-checkbox
      class="nonreactive-checkbox"
      :value="state.check.value"
      :disabled="readonly"
      @change="updateNonreactive"
    >
      Nonreactive
    </md-checkbox>
  </div>
</template>

<script>
import states from '~lib/common/config/states';

export default {
  name: 'nonreactive-check',
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      state: {
        eyeStates: [
          states.find(state => state.id === 'leftEye'),
          states.find(state => state.id === 'rightEye'),
        ],
        check: {
          value: false
        },
      },
    };
  },
  mounted() {
    this.state.check = this.getData(this.ikey) || {};
    if (!this.state.check.id) {
      this.state.check.id = 'LEFT_EYE';
      this.state.check.value = false;
    }
    this.emitter.trigger('process', this.control);
  },
  methods: {
    updateEye(value) {
      this.state.check.id = value;
      this.update();
    },
    updateNonreactive(value) {
      this.state.check.value = value;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'EYE_STATE_RESPONSIVE',
        ...this.state.check,
      });
      this.emitter.trigger('process', this.control);
      this.$forceUpdate();
    },
  }
}
</script>

<style scoped>
.nonreactive-check {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: white;
}

.nonreactive-checkbox {
  margin: 0 !important;
  padding: 8px;
  color: black;
}
</style>